import { Component, Input } from '@angular/core';

import { FormsModule } from '@angular/forms';
@Component({
    selector: 'app-cell-plan-status-toggle',
    templateUrl: './cell-plan-status-toggle.component.html',
    styleUrl: './cell-plan-status-toggle.component.css',
    imports: [FormsModule]
})
export class CellPlanStatusToggleComponent {
 @Input() value: any;
  @Input() row: any;
  @Input() onClick!: (event: MouseEvent, value: any, row: any) => void;


  onToggleChange(event: any) {
    
    this.onClick(event, this.value, this.row);
  }
}
